import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseContractSignatureReminderTemplates = [
  {
    id: '-209001',
    language: Language.EN,
    subject: 'Reminder: Lease contract to be signed',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_CONTRACT_SIGNATURE_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Dear tenant,</p>
          <p>We kindly remind you to sign your lease by connecting to your account: {{connectionLink}}.</p>
          <p>Kind regards.</p>
      `,
  },
  {
    id: '-209002',
    language: Language.FR,
    subject: 'Rappel: contrat de bail à signer',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_CONTRACT_SIGNATURE_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Cher/Chère locataire,</p>
          <p>Nous vous invitons à signer votre bail en vous connectant à votre compte utilisateur: {{connectionLink}}.</p>
          <p>Bien à vous.</p>
      `,
  },
  {
    id: '-209003',
    language: Language.NL,
    subject: 'Herinnering: te ondertekenen huurcontract',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_CONTRACT_SIGNATURE_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Beste huurder,</p>
          <p>We nodigen u uit om uw huurcontract te ondertekenen door in te loggen op uw account: {{connectionLink}}.</p>
          <p>Groeten.</p>
      `,
  },
  {
    id: '-209004',
    language: Language.DE,
    subject: 'Erinnerung: Zu unterzeichnender Mietvertrag',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_CONTRACT_SIGNATURE_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Sehr geehrte/r Mieter/in,</p>
          <p>Wir erinnern Sie daran, Ihren Mietvertrag zu unterzeichnen, indem Sie sich in Ihr Konto einloggen: {{connectionLink}}.</p>
          <p>Mit freundlichen Grüßen.</p>
      `,
  },
];
